import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavHeaderRoutingModule } from './nav-header-routing.module';
import { NavHeaderComponent } from './nav-header.component';
import { MobileComponent } from './mobile/mobile.component';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  exports:[
    NavHeaderComponent
  ],
  declarations: [
    NavHeaderComponent,
    MobileComponent
  ],
  imports: [
    CommonModule,
    NavHeaderRoutingModule,
    NgbCollapseModule,
    NgbDropdownModule
  ]
})
export class NavHeaderModule { }
